import React from "react";
import { ArrowRight, Check } from "lucide-react";

const About = () => (
  <section id="about" className="cvx-section bg-white overflow-hidden">
    <div className="container mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-24 items-center">
        <div>
          <p className="cvx-kicker mb-5">Why CloudVetX</p>
          <h2 className="cvx-section-title mb-7">A calmer way to run a busy clinic.</h2>
          <p className="text-lg text-slate-600 leading-relaxed max-w-xl mb-8">
            The best clinic software should make everyday work feel clearer.
            CloudVetX brings clinical and operational tasks together, with
            room for your team to shape how the product develops.
          </p>
          <a href="/#contact" className="inline-flex items-center gap-2 text-emerald-800 font-semibold hover:underline">
            Tell us about your clinic <ArrowRight size={18} aria-hidden="true" />
          </a>
        </div>
        <div className="cvx-about-visual">
          <img
            src="/images/responsive/vet-clinic-1280.jpg"
            srcSet="/images/responsive/vet-clinic-800.jpg 800w, /images/responsive/vet-clinic-1280.jpg 1280w"
            sizes="(max-width: 1023px) 100vw, 45vw"
            alt="Veterinary clinic interior"
            width="1280"
            height="853"
            loading="lazy"
          />
          <div className="cvx-about-panel">
          <div className="flex items-center justify-between pb-7 border-b border-emerald-900/10">
            <span className="text-xs uppercase tracking-[0.18em] text-emerald-700 font-bold">One connected workspace</span>
            <span className="text-emerald-800/40 text-3xl font-serif">✦</span>
          </div>
          {[
            ["01", "Know what is happening today", "Appointments and clinic tasks in view."],
            ["02", "Follow each patient's story", "Case notes and supporting records together."],
            ["03", "Keep operations connected", "Billing and stock within the clinic workflow."],
          ].map(([number, title, detail]) => (
            <div key={number} className="flex gap-5 sm:gap-8 py-6 border-b border-emerald-900/10 last:border-0">
              <span className="text-sm font-semibold text-emerald-700/60 pt-1">{number}</span>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-emerald-950 mb-1">{title}</h3>
                <p className="text-slate-600">{detail}</p>
              </div>
              <Check size={20} className="text-emerald-700 shrink-0 mt-1" aria-hidden="true" />
            </div>
          ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
export default About;
